import thisVue from "@/main";

export function useModal() {
    const modalController = thisVue.$bvModal

    return {
        modalController
    }
}